import { observer } from 'mobx-react';
import { T } from '../../Translations';

function Head() {
  return (
    <>
      <div className="flex items-center mb-5">
        <h2 className="text-2xl font-semibold text-gray-900 items-center">
          <T kind="Products" />
        </h2>
      </div>
    </>
  );
}

export default observer(Head);
